// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ViewRows(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ViewRows" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M20 14V10H4L4 14H20ZM20 20V16H4L4 20H20ZM4 8H20V4L4 4L4 8Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ViewRows.js.map